import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@services/api'

export function useBatchExpiration() {
  return useQuery({
    queryKey: ['batch-expiration'],
    queryFn: async () => {
      const res = await apiClient.get<any>('/batch-tracking/expiration')
      return res
    },
  })
}

export function useFEFORecommendation(productId?: number) {
  return useQuery({
    queryKey: ['fefo-recommendation', productId],
    queryFn: async () => {
      const res = await apiClient.get<any>('/batch-tracking/fefo-recommendation', {
        params: { productId },
      })
      return res
    },
  })
}

export function usePackedGoodsTracking() {
  return useQuery({
    queryKey: ['packed-goods-tracking'],
    queryFn: async () => {
      const res = await apiClient.get<any>('/batch-tracking/packed-goods')
      return res
    },
  })
}

export function useActiveRecalls() {
  return useQuery({
    queryKey: ['active-recalls'],
    queryFn: async () => {
      const res = await apiClient.get<any>('/batch-tracking/recalls')
      return res
    },
  })
}

export function useFlagBatchRecall() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: {
      batchId: number
      reason: string
      severity?: string
    }) => {
      const res = await apiClient.post<any>('/batch-tracking/recall', data)
      return res
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['active-recalls'] })
      queryClient.invalidateQueries({ queryKey: ['batch-expiration'] })
    },
  })
}

export function useSalesReport(startDate?: string, endDate?: string) {
  return useQuery({
    queryKey: ['sales-report', startDate, endDate],
    queryFn: async () => {
      const res = await apiClient.get<any>('/reports/sales', {
        params: { startDate, endDate },
      })
      return res
    },
  })
}

export function useInventoryReport() {
  return useQuery({
    queryKey: ['inventory-report'],
    queryFn: async () => {
      const res = await apiClient.get<any>('/reports/inventory')
      return res
    },
  })
}

export function useCollectionsReport(startDate?: string, endDate?: string) {
  return useQuery({
    queryKey: ['collections-report', startDate, endDate],
    queryFn: async () => {
      const res = await apiClient.get<any>('/reports/collections', {
        params: { startDate, endDate },
      })
      return res
    },
  })
}
